import { jsx as n } from "react/jsx-runtime";
import { Container as s } from "./styles.js";
const t = ({
  children: m,
  vertical: p = 0,
  horizontal: r = 0,
  top: o = p,
  right: a = r,
  bottom: e = p,
  left: d = r,
  ...i
}) => /* @__PURE__ */ n(s, { $padding: [o, a, e, d], ...i, children: m });
t.displayName = "Spacer";
export {
  t as Spacer
};
//# sourceMappingURL=Spacer.js.map
